module.exports = __webpack_public_path__ + "static/media/San Babila.c198079f.jpg";